<template>
  <div class="detail">
    <detail-header :info="info"></detail-header>
    <detail-img img="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_market%402x.png"></detail-img>
    <detail-img img="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_painpoints%402x.png"></detail-img>
    <detail-img img="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_frame%402x.png"></detail-img>
    <detail-img img="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_program%402x.png"></detail-img>
    <detail-program :program="program"></detail-program>
  </div>
</template>

<script>
import { getItem } from './data'
import DetailHeader from './detailHeader'
import DetailImg from './detailImg'
import DetailProgram from './detailProgram'
export default {
  components: {
    DetailHeader,
    DetailImg,
    DetailProgram
  },
  data () {
    return {
      info: {}
    }
  },
  computed: {
    program () {
      return this.info.program ? this.info.program : []
    }
  },
  mounted () {
    this.info = getItem(3)
  }
}
</script>
<style scoped>
.detail {
  background-color: #FAFAFA;
}
@media (max-width: 1199px) and (min-width: 992px){
}
@media (max-width: 991px) and (min-width: 768px){
}
@media screen and (max-width: 767px){
}
</style>


// WEBPACK FOOTER //
// src/components/solution/detail3.vue